import modalsTypes from "./modals.types";

const INITIAL_STATE = {
    changePassModal: false,
    settingModal: false,
    icons: false,
    signModal: false,
    statusModal: false,
    reportsModal: false,
    drawer: false,
    payment: true,
    toggleSuccess: false,
    initModal: false
};

const modalsReducer = (state = INITIAL_STATE , action) => {
    switch (action.type){
        case modalsTypes.TOGGLE_ICONS :
            return{
                ...state,
                icons: !state.icons
            };
        case modalsTypes.TOGGLE_CHANGE_PASS :
            return{
                ...state,
                changePassModal: !state.changePassModal
            };
        case modalsTypes.TOGGLE_SETTING_MODAL :
            return{
                ...state,
                settingModal: !state.settingModal
            };
        case modalsTypes.TOGGLE_SIGN_MODAL :
            return{
                ...state,
                signModal: !state.signModal
            };
        case modalsTypes.TOGGLE_STATUS_MODAL :
            return{
                ...state,
                statusModal: !state.statusModal
            };
        case modalsTypes.TOGGLE_REPORTS_MODAL :
            return{
                ...state,
                reportsModal: !state.reportsModal
            };
        case modalsTypes.TOGGLE_DRAWER :
            return{
                ...state,
                drawer: !state.drawer
            };
        case modalsTypes.TOGGLE_PAYMENT :
            return{
                ...state,
                payment: !state.payment
            };
        case modalsTypes.TOGGLE_SUCCESS :
            return{
                ...state,
                toggleSuccess: !state.toggleSuccess
            };
        case modalsTypes.TOGGLE_INIT_MODAL :
            return{
                ...state,
                initModal: !state.initModal
            };
        default:
            return state
    }
}

export default modalsReducer;